module.exports = __webpack_public_path__ + "img/用车发票示例.92d75b5a.png";